/**
 * 	jQuery Extensions
 */
$.extend({
	debounced: function(e, t, n, o) {
		3 == arguments.length && "boolean" != typeof n && (o = n, n = !1);
		var r;
		return function() {
			var u = arguments;
			o = o || this, n && !r && e.apply(o, u), clearTimeout(r), r = setTimeout(function() {
				n || e.apply(o, u), r = null
			}, t)
		}
	},
	hook: function(e) {
		var t;
		return t = e && "*" !== e ? '[data-hook~="' + e + '"]' : "[data-hook]", $(t)
	},
	throttle: function(e, t, n) {
		var o, r, u, a = null,
			l = 0,
			i = "Expected a function";
		if (n || (n = {}), "function" != typeof e) throw new TypeError(i);
		var c = function() {
			l = n.leading === !1 ? 0 : (new Date).getTime(), a = null, u = e.apply(o, r), a || (o = r = null)
		};
		return function() {
			var i = (new Date).getTime();
			l || n.leading !== !1 || (l = i);
			var p = t - (i - l);
			return o = this, r = arguments, 0 >= p || p > t ? (a && (clearTimeout(a), a = null), l = i, u = e.apply(o, r), a || (o = r = null)) : a || n.trailing === !1 || (a = setTimeout(c, p)), u
		}
	}
});
